import type { ReactNode } from 'react'
import styles from './ProInputEditor.module.css'
import { FormGroup, FormRow, Help } from '@/components/Form'
import {
  RadioButtonGroup,
  RadioButtonItem,
} from '@/components/RadioButtonGroup'
import {
  CurrentMemberInfo,
  type CurrentMemberInfoProps,
} from '@/features/jobs/TransferJobDialog/CurrentMemberInfo'

export interface ProFilterProps {
  isQualifiedOnly: boolean
  isAnyAvailable: boolean
  onSelectQualifiedOnly: () => unknown
  onSelectAnyAvailable: () => unknown
}

export function ProFilter({
  isQualifiedOnly,
  isAnyAvailable,
  onSelectQualifiedOnly,
  onSelectAnyAvailable,
}: ProFilterProps) {
  return (
    <>
      <div className={styles.proFilterTitle}>
        What kind of Pro are you looking for?
      </div>
      <RadioButtonGroup size="big-wide">
        <RadioButtonItem
          onPress={onSelectQualifiedOnly}
          active={isQualifiedOnly}
          testId="transfer-to-pro-select-qualified"
        >
          Qualified only
        </RadioButtonItem>
        <RadioButtonItem
          onPress={onSelectAnyAvailable}
          active={isAnyAvailable}
          testId="transfer-to-pro-select-all"
        >
          Any available
        </RadioButtonItem>
      </RadioButtonGroup>
    </>
  )
}

export interface ProInputEditorProps {
  currentPro?: Omit<CurrentMemberInfoProps, 'subtitle'>
  proFilter: ProFilterProps
  proSelect: ReactNode
  proError?: string
}

export function ProInputEditor({
  currentPro,
  proFilter,
  proSelect,
  proError,
}: ProInputEditorProps) {
  return (
    <>
      {currentPro && (
        <FormRow>
          <FormGroup>
            <CurrentMemberInfo {...currentPro} subtitle="Current Pro" />
          </FormGroup>
        </FormRow>
      )}
      <FormRow>
        <ProFilter {...proFilter} />
      </FormRow>
      <FormRow>
        <FormGroup className={styles.selectProContainer}>
          <div className={styles.newProLabel}>New Pro</div>
          {proSelect}
          <Help error={proError} />
        </FormGroup>
      </FormRow>
    </>
  )
}

export interface ProSearchItemDetailsProps {
  name?: string
  email?: string
}

export function ProSearchItemDetails({
  name,
  email,
}: ProSearchItemDetailsProps) {
  return (
    <>
      <div className={styles.proName}>{name}</div>
      <div className={styles.proEmail}>{email}</div>
    </>
  )
}
